import { POSIcon } from '@publicisgroupe/p-os-components';
import { useCallback, useState } from 'react';
import { t } from '../../utils/resources';
import { RenderModules } from './RenderModules/RenderModules';
import { useModuleRouter } from 'hooks/useModuleRouter';
import './TopMenu.less';

export const TopMenu = () => {
  const [activeMenuItem, setActiveMenuItem] = useState<string>();
  const permissionsMatrix = useModuleRouter();

  const handleActiveMenuItem = useCallback((item?: string) => {
    setActiveMenuItem(item ? item.replace('/', '') : '');
  }, []);

  return (
    <div id="top-menu" className="mobile hidden">
      <div className="mega-dropdown ui text menu">
        {permissionsMatrix.length > 1 && (
          <>
            <div
              className={`mega-dropdown-item item ${
                activeMenuItem === 'make-it-right' ? 'active' : ''
              }`}
              onMouseEnter={() => handleActiveMenuItem('make-it-right')}
              data-testid="make-it-right"
            >
              <POSIcon icon="make-it-right" />
              {t('Menu.MakeItRight')}
            </div>

            <div
              className={`mega-dropdown-item item ${
                activeMenuItem === 'make-it-magic' ? 'active' : ''
              }`}
              onMouseEnter={() => handleActiveMenuItem('make-it-magic')}
              data-testid="make-it-magic"
            >
              <POSIcon icon="make-it-magic" />
              {t('Menu.MakeItMagic')}
            </div>

            <div
              className={`mega-dropdown-item item ${
                activeMenuItem === 'make-it-work' ? 'active' : ''
              }`}
              onMouseEnter={() => handleActiveMenuItem('make-it-work')}
              data-testid="make-it-work"
            >
              <POSIcon icon="make-it-work" />
              {t('Menu.MakeItWork')}
            </div>
          </>
        )}
      </div>
      <RenderModules
        selectedMenuItem={activeMenuItem ?? ''}
        handleActiveMenuItem={handleActiveMenuItem}
      />
    </div>
  );
};
